export default __webpack_public_path__ + "static/media/STATQAM_2024_RLDynamic.95d564c0.pdf";